import SortListOptionsEnum from '../enums/SortListOptionsEnum.js';
export default class LabelUtility {
    /**
     * Get label for button or sort list option.
     *
     * @param option The option.
     * @param localizedInformationOrTranslations The localized information or translations object.
     * @returns Current label for button.
     */
    static getLabel(option, localizedInformationOrTranslations) {
        const translations = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations
            : localizedInformationOrTranslations;
        switch (option) {
            case SortListOptionsEnum.aisleLocation:
                return translations.pickingListSortAisleLocation;
            case SortListOptionsEnum.packageSize:
                return translations.pickingListSortPackageSize;
            case SortListOptionsEnum.packageWeight:
                return translations.pickingListSortPackageWeight;
            case SortListOptionsEnum.default:
                return translations.pickingListSortDefault;
            default:
                return translations.pickingListSortTitle;
        }
    }
}
//# sourceMappingURL=LabelUtility.js.map